angular.module 'app'
.controller 'AuthenticationInfoController', ($timeout, $stateParams, $scope, $http, $state, $ionicPopup, config, activeUser, ionicMaterialInk) ->

  if _.isUndefined activeUser.user.openid
    $state.go('focus_on', {wechat_id: activeUser.wechat_id})

  $scope.ui =
    baseUrl: config.api.baseUrl
    status: if $stateParams.status then $stateParams.status else '0'
    types: 'parent'
    homepage: activeUser.homepage
    userInfo: activeUser.user
    classData: {}
    student_id: ''
    pstudent_id: ''
    student_class: ''
    student_grade: ''
    student_num: ''
    identity: 'mother'
    school_num: '019'
    verification_code: ''
    parent_code: ''

  do findParent = ->
    $http.get "#{config.api.baseUrl}/cumpus/student",
      params:
        parent_openid: activeUser.user.openid
        group_id: activeUser.group_id
    .then (res) ->
      if res.data.count > 0 and $stateParams.status is '0'
        $state.go("app.verify_success", {user_id: res.data.data[0]._id, status: 'parent'})
      else
        findStudent()
      $timeout (->
        ionicMaterialInk.displayEffect()
      ), 1000
    .catch (error) ->

  findStudent = ->
    $http.get "#{config.api.baseUrl}/cumpus/student",
      params:
        openid: activeUser.user.openid
        group_id: activeUser.group_id
    .then (res) ->
      if res.data.count > 0  and $stateParams.status is '0'
        $state.go("app.verify_success", {user_id: res.data.data[0]._id, status: 'student'})
      $timeout (->
        ionicMaterialInk.displayEffect()
      ), 1000
    .catch (error) ->

  do findClass = ->
    $http.get "#{config.api.baseUrl}/cumpus/class",
      params:
        group_id: activeUser.group_id
    .then (res) ->
      res.data.student_grade = res.data.student_grade.sort()
      res_class = []
      res_grade = []
      _.each res.data.student_class, (val) ->
        obj = {}
        obj.name = val
        obj.key = switch val
          when "甲" then 1
          when "乙" then 2
          when "丙" then 3
          when "丁" then 4
          when "戊" then 5
          when "己" then 6
          when "庚" then 7
          when "辛" then 8
          when "壬" then 9
          when "癸" then 10
        res_class.push obj
      res.data.student_class = _.sortBy res_class, "key"
      _.each res.data.student_grade, (val) ->
        obj = {}
        obj.name = val
        obj.key = switch val
          when "幼兒" then 1
          when "幼初" then 2
          when "幼高" then 3
          when "小一" then 4
          when "小二" then 5
          when "小三" then 6
          when "小四" then 7
          when "小五" then 8
          when "小六" then 9
          when "初一" then 10
          when "初二" then 11
          when "初三" then 12
          when "高一" then 13
          when "高二" then 14
          when "高三" then 15
        res_grade.push obj
      res.data.student_grade = _.sortBy res_grade, "key"
      $scope.ui.classData = res.data
    .catch (error) ->


  $scope.toCheck = ->
    params =
      openid: activeUser.user.openid
      original_id: activeUser.user.original_id
      group_id: activeUser.group_id
      student_id: $scope.ui.pstudent_id
      school_num: $scope.ui.school_num
      student_grade: $scope.ui.student_grade
      student_class: $scope.ui.student_class
      student_num: $scope.ui.student_num
      identity: $scope.ui.identity
      is_show: true
    if $scope.ui.types is 'parent'
      if $scope.ui.parent_code.length > 0
        params.parent_code = $scope.ui.parent_code
      if $scope.ui.pstudent_id is ""
        $ionicPopup.alert(
          title: "錯誤"
          template: "請輸入學生帳號"
          buttons: [
            {text: '<b>關閉</b>', type: 'button-positive'}
          ]
        )
        return
      if $scope.ui.student_grade is "" or $scope.ui.student_grade is null
        $ionicPopup.alert(
          title: "錯誤"
          template: "請選擇學生年級"
          buttons: [
            {text: '<b>關閉</b>', type: 'button-positive'}
          ]
        )
        return
      if $scope.ui.student_class is "" or $scope.ui.student_class is null
        $ionicPopup.alert(
          title: "錯誤"
          template: "請選擇學生班級"
          buttons: [
            {text: '<b>關閉</b>', type: 'button-positive'}
          ]
        )
        return
      if $scope.ui.student_num is ""
        $ionicPopup.alert(
          title: "錯誤"
          template: "請輸入學生學號"
          buttons: [
            {text: '<b>關閉</b>', type: 'button-positive'}
          ]
        )
        return
      if $scope.ui.identity is ""
        $ionicPopup.alert(
          title: "錯誤"
          template: "請輸入家長身份"
          buttons: [
            {text: '<b>關閉</b>', type: 'button-positive'}
          ]
        )
        return
      params.phone = $scope.ui.phone
      params.student_num = $scope.ui.student_num
      $http.put "#{config.api.baseUrl}/cumpus/certification/parents", params
      .then (res) ->
        $state.go("app.verify_success", {user_id: res.data, status: 'parent'})
      .catch (res) ->
        template = '驗證失敗！'
        if res.data.error.indexOf('parent is verified') > -1
          template = '已被驗證！'
        $ionicPopup.alert(
          title: "錯誤"
          template: template
          buttons: [
            {text: '<b>關閉</b>', type: 'button-positive'}
          ]
        )
    else
      if $scope.ui.student_id is ""
        $ionicPopup.alert(
          title: "错误"
          template: "請輸入學生帳號"
          buttons: [
            {text: '<b>关闭</b>', type: 'button-positive'}
          ]
        )
        return
      if $scope.ui.verification_code is ""
        $ionicPopup.alert(
          title: "错误"
          template: "請輸入驗證編碼"
          buttons: [
            {text: '<b>关闭</b>', type: 'button-positive'}
          ]
        )
        return
      params.verification_code = $scope.ui.verification_code
      params.student_id = $scope.ui.student_id
      $http.put "#{config.api.baseUrl}/cumpus/certification/students", params
      .then (res) ->
        $state.go("app.verify_success", {user_id: res.data, status: 'student'})
      .catch (res) ->
        template = '驗證失敗！'
        if res.data.error.indexOf('student is verified') > -1
          template = '已被驗證！'
        $ionicPopup.alert(
          title: "錯誤"
          template: template
          buttons: [
            {text: '<b>關閉</b>', type: 'button-positive'}
          ]
        )
